<template>
  <div class="page-sign">
    <AppAlert />
    <AppSpinner />
    <div class="sign-logo">
      <img :src="logoUrl" width="160" />
    </div>
    <div class="card col-sm-12 col-md-8 col-lg-6 pull-right">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppAlert from '@/components/theme/Alert';
import AppSpinner from '@/components/theme/Spinner';

export default {
  name: 'Signin',
  components: {
    AppSpinner,
    AppAlert,
  },
  data() {
    return {
      logoUrl: 'https://pagcerto-public.s3.amazonaws.com/logo-white.png',
    };
  },
};
</script>
